import { render } from "./CarouselDots.vue?vue&type=template&id=4786a68a&scoped=true&ts=true"
import script from "./CarouselDots.vue?vue&type=script&lang=ts"
export * from "./CarouselDots.vue?vue&type=script&lang=ts"

import "./CarouselDots.vue?vue&type=style&index=0&id=4786a68a&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4786a68a"]])

export default __exports__